import { useCallback, useState } from 'preact/hooks';

export default function usePreviewAnimations({
  setMilestones,
  setCurrentAmount,
}) {
  const [isPreviewingAnimation, setIsPreviewingAnimation] = useState(false);
  const startAnimation = useCallback(
    (animation) => {
      const isMilestone = animation === 'milestone';

      setIsPreviewingAnimation(true);

      if (isMilestone) setMilestones(true);
      else setCurrentAmount(1000);

      const timeout = setTimeout(() => {
        if (isMilestone) setMilestones(false);
        else setCurrentAmount(750);

        setIsPreviewingAnimation(false);

        return () => {
          clearTimeout(timeout);
        };
      }, 10000);
    },
    [setCurrentAmount, setMilestones]
  );

  return {
    isPreviewingAnimation,
    startAnimation,
  };
}
